import { CheckCircle2, AlertTriangle, Info } from 'lucide-react';
import { useActiveToast } from '../../lib/useToast';
import type { ToastVariant } from '../../lib/toast';

const VARIANT_STYLE: Record<
  ToastVariant,
  { container: string; icon: typeof Info }
> = {
  info: {
    container: 'border-zinc-800 bg-zinc-900 text-white',
    icon: Info,
  },
  success: {
    container: 'border-emerald-700 bg-emerald-600 text-white',
    icon: CheckCircle2,
  },
  warning: {
    container: 'border-amber-700 bg-amber-600 text-white',
    icon: AlertTriangle,
  },
};

export function ToastHost(): JSX.Element {
  const toast = useActiveToast();
  const style = toast ? VARIANT_STYLE[toast.variant] : null;
  const Icon = style?.icon;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="pointer-events-none fixed inset-x-0 bottom-20 z-40 flex justify-center px-4 pb-[env(safe-area-inset-bottom)]"
    >
      {toast && style && Icon ? (
        <div
          key={toast.id}
          className={`pointer-events-auto flex max-w-[480px] items-center gap-2 rounded-lg border px-4 py-3 text-sm font-semibold shadow-lg motion-safe:animate-[toast-in_200ms_ease-out] ${style.container}`}
        >
          <Icon aria-hidden="true" className="size-4 shrink-0" />
          <span>{toast.message}</span>
        </div>
      ) : null}
    </div>
  );
}
